import { render, staticRenderFns } from "./GalleryMasonry.vue?vue&type=template&id=3d843079&"
import script from "./GalleryMasonry.vue?vue&type=script&lang=js&"
export * from "./GalleryMasonry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d843079')) {
      api.createRecord('3d843079', component.options)
    } else {
      api.reload('3d843079', component.options)
    }
    module.hot.accept("./GalleryMasonry.vue?vue&type=template&id=3d843079&", function () {
      api.rerender('3d843079', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/partial/product/gallery/GalleryMasonry.vue"
export default component.exports